import { useRef, useState } from "react";
import { Camera } from "@phosphor-icons/react";
import { compressImage } from "@/lib/compressImage";

// Mandatory vehicle photo: opens the rear camera on phones.
export default function PhotoCapture({ value, onChange, testId = "gate-photo" }) {
  const input = useRef(null);
  const [preview, setPreview] = useState("");
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    const small = await compressImage(f).catch(() => f);
    setPreview(URL.createObjectURL(small));
    onChange(small);
  };
  return (
    <div>
      <button type="button" onClick={() => input.current?.click()} data-testid={`${testId}-button`}
        className={`w-full border-2 border-dashed ${value ? "border-[#047857]" : "border-[#b91c1c]"} bg-canvas flex items-center justify-center gap-2 py-3 text-sm font-semibold`}>
        <Camera size={18} weight="bold" /> {value ? "Retake vehicle photo" : "Take vehicle photo (required)"}
      </button>
      {value && preview && <img src={preview} alt="Vehicle" data-testid={`${testId}-preview`} className="mt-2 w-full max-h-56 object-cover border border-canvas-line" />}
      <input ref={input} type="file" accept="image/*" capture="environment" className="hidden" onChange={pick} data-testid={`${testId}-input`} />
    </div>
  );
}
